module.exports = __webpack_public_path__ + "img/6-fox_v8e.c41d99cd.png";